var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import useSession from '../hooks/use-session';
var Turnout = function Turnout(route) {
  var location = useLocation();
  var _useSession = useSession(),
    isAuthed = _useSession.isAuthed;
  return React.createElement(Route, {
    path: route.path,
    exact: route.exact !== null ? route.exact : true,
    render: function render(props) {
      if (route.private && isAuthed || !route.private) {
        return React.createElement(route.component, _extends({}, route, props));
      }
      return React.createElement(Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: location
          }
        }
      });
    }
  });
};
export default Turnout;